export type SchoolTheme = {
  accentColor: string;
  titleColor: string;
  iconPath: string | null;
};

const DEFAULT_SCHOOL_THEME: SchoolTheme = {
  accentColor: 'blue.500',
  titleColor: 'blue.500',
  iconPath: null,
};

/**
 * Keyed by the taxonomy URI of a catalog item's primary school, which is the
 * only stable school identifier the catalog API returns. School names are
 * localized and slugs are not present on the taxonomy, so neither can be used.
 */
const SCHOOL_THEMES_BY_TAXONOMY_URI: Record<string, SchoolTheme> = {
  // Artificial Intelligence
  'taxonomy:b8b37a22-80bb-45fe-8c41-7d7179cc306d': {
    accentColor: 'blue.500',
    titleColor: 'blue.500',
    iconPath: '/images/school-icons/artificial-intelligence.svg',
  },
  // Data Science
  'taxonomy:0797c703-1d76-487a-9219-b84cf74b66a5': {
    accentColor: 'blue.500',
    titleColor: 'blue.500',
    iconPath: '/images/school-icons/data-science.svg',
  },
  // Programming and Development
  'taxonomy:d5b00600-d85f-4c4a-a493-e7ed9374be89': {
    accentColor: 'cyan.500',
    titleColor: 'cyan.700',
    iconPath: '/images/school-icons/programming.svg',
  },
  // Cloud Computing
  'taxonomy:37efa4cd-9fb8-48ed-a3be-4fe488e3704f': {
    accentColor: 'cyan.500',
    titleColor: 'cyan.700',
    iconPath: '/images/school-icons/cloud-computing.svg',
  },
  // Autonomous Systems
  'taxonomy:c7075247-28e1-4047-9a11-d86f2a3143d5': {
    accentColor: 'orange.500',
    titleColor: 'orange.700',
    iconPath: '/images/school-icons/autonomous-systems.svg',
  },
  // Cybersecurity
  'taxonomy:b4a305f0-00bb-4c2c-bcfd-e875edcdcd61': {
    accentColor: 'orange.500',
    titleColor: 'orange.700',
    iconPath: '/images/school-icons/cybersecurity.svg',
  },
  // Product Management
  'taxonomy:0dba323e-c4c6-4d09-bf98-365cf420a83a': {
    accentColor: 'purple.500',
    titleColor: 'purple.500',
    iconPath: '/images/school-icons/product-management.svg',
  },
  // Business
  'taxonomy:63c3498c-9e8b-4d85-bcd4-2843d519ee04': {
    accentColor: 'purple.500',
    titleColor: 'purple.500',
    iconPath: '/images/school-icons/business.svg',
  },
  // Executive Leadership
  'taxonomy:1ab68afb-1a62-434e-bffd-7d0f18975299': {
    accentColor: 'purple.500',
    titleColor: 'purple.500',
    iconPath: '/images/school-icons/executive-leadership.svg',
  },
  // Career Resources
  'taxonomy:c16ea252-b5e1-4b2b-b56c-f953e4eff453': {
    accentColor: 'purple.500',
    titleColor: 'purple.500',
    iconPath: '/images/school-icons/career-resources.svg',
  },
};

export function getSchoolTheme(schoolTaxonomyUri?: string): SchoolTheme {
  if (!schoolTaxonomyUri) {
    return DEFAULT_SCHOOL_THEME;
  }

  return SCHOOL_THEMES_BY_TAXONOMY_URI[schoolTaxonomyUri] ?? DEFAULT_SCHOOL_THEME;
}
